'use client';

import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type Context = {
  setEmail: Dispatch<SetStateAction<string>>;
  email: string;
};

const EmailsContext = createContext<Context | null>(null);

interface Props {
  children: ReactNode;
}

const EmailsProvider = ({ children }: Props) => {
  const [email, setEmail] = useState('');

  const value = { email, setEmail };

  return (
    <EmailsContext.Provider value={value}>{children}</EmailsContext.Provider>
  );
};

function useEmails() {
  const context = useContext(EmailsContext);
  if (!context) throw new Error('useEmails requires a context!');

  return context;
}

export { EmailsProvider, useEmails };
